import { Injectable } from '@angular/core';
import { HttpManagerService } from 'http-manager';
import { LanguageTabConfig, LanguageTabService } from 'language-tab';
import { TranslateService } from '@ngx-translate/core';
import { EventManagerService } from 'event-manager';
import { WincoEvents } from '../enums/winco-events..enum';

/**
 * Servicio que controla la gestión de idiomas
 */
@Injectable({
  providedIn: 'root'
})
export class LanguageService extends LanguageTabService
{
  constructor(private httpManager: HttpManagerService,
              httpManagerService: HttpManagerService,
              translate: TranslateService,
              config: LanguageTabConfig,
              eventManagerService: EventManagerService)
  {
    super (httpManagerService, translate, eventManagerService, config);
  }

  /**
   * Almacena el idioma seleccionado en una sesión local
   * @param language Código ISO del idioma seleccionado
   */
  override setLanguage(language: string)
  {
    localStorage.setItem('winco.language', language);
    this.httpManager.setLanguage(language);
    this.eventManagerService.emitEvent(WincoEvents.LANGUAGE_SOURCE, language);
  }
}
